module.exports = __webpack_public_path__ + "static/4-ea3dccf50fe83bf24c2bc2b1928b3a98.jpg";